import { AxiosError } from 'axios';

import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { TourEventBasic } from '../entities/project-tour-ontour-event.entity';

type Params = {
  apiToken: string;
  spectacleId: string;
  artistId: string;
  startDate: string;
  endDate: string;
};

type Result = TourEventBasic[];

export const importTourEventsFromOrfeo = createAppAsyncThunk(
  'projectTourOntour/importTourEventsFromOrfeo',
  async (
    params: Params,
    { extra: { projectTourOntourGateway, snackbarGateway } },
  ): Promise<Result> => {
    let tourEventsBasic: TourEventBasic[];
    try {
      tourEventsBasic =
        await projectTourOntourGateway.importTourEventsFromOrfeo(
          params.apiToken,
          params.spectacleId,
          params.artistId,
          params.startDate,
          params.endDate,
        );
    } catch (error) {
      const axiosError = error as AxiosError<{ name: string }>;
      if (axiosError?.response?.data?.name === 'OrfeoBadTokenException') {
        showSnackbarBadTokenError(snackbarGateway);
        throw error;
      }
      showSnackbarError(snackbarGateway);
      throw error;
    }
    return tourEventsBasic;
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('ImportTourEventsFromOrfeo.Message.error'));
}

function showSnackbarBadTokenError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(
    translate('ImportTourEventsFromOrfeo.Message.bad-token-error'),
  );
}
